import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class RelacioanalizisesKerdesDto extends IdentifiableDto {
	constructor() {
		super();

		this.sorszam = null;
		this.alSorszam = null;
		this.subSorszam = 0;
		this.csorszam = null;

		this.leiras = null;
		this.leirasPlaintext = null;
		this.magyarazat = null;
		this.magyarazatPlaintext = null;

		this.nemperm = false;
		this.statuszId = false;
		
		this.feladatCsoport = null;
		this.fejezet = null;
    }

	setup(props) {
		super.setup(props);
		this.sorszam = props.sorszam;
		this.alSorszam = props.alSorszam;
		this.subSorszam = props.subSorszam;
        this.csorszam = props.csorszam;

		this.leiras = props.leiras;
		this.leirasPlaintext = props.leirasPlaintext;
		this.magyarazat = props.magyarazat;
		this.magyarazatPlaintext = props.magyarazatPlaintext;

		this.nemperm = props.nemperm;
		this.statuszId = props.statuszId;
		
		this.feladatCsoport = props.feladatCsoport;
		this.fejezet = props.fejezet;

		return this;
	}

	getAsString(key) {
		if (key === 'feladatCsoport') {
			return this.feladatCsoport != null ? this.feladatCsoport.name : ''
		}
		if (key === 'fejezet') {
			return this.fejezet != null ? this.fejezet.name : ''
		}
		return super.getAsString(key);
	}
}

export default RelacioanalizisesKerdesDto;
